<template>
  <van-field
    :model-value="displayLabel"
    :name="name"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled"
    :required="required"
    :rules="rules"
    is-link
    readonly
    clickable
    @click="!disabled && (showPicker = true)"
  />
  <van-popup v-model:show="showPicker" position="bottom">
    <van-picker
      :columns="columns"
      :columns-field-names="columnNames"
      @confirm="onConfirm"
      @cancel="showPicker = false"
    />
  </van-popup>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  name: {
    type: String,
    required: true
  },
  label: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: '请选择'
  },
  columns: {
    type: Array,
    default: () => []
  },
  columnNames: {
    type: Object,
    default: () => ({ text: 'dictLabel', value: 'dictValue' })
  },
  disabled: {
    type: Boolean,
    default: false
  },
  required: {
    type: Boolean,
    default: false
  },
  rules: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['update:modelValue', 'change', 'confirm'])

const showPicker = ref(false)

// 根据当前值查找对应的 label
const displayLabel = computed(() => {
  if (!props.modelValue || !props.columns.length) return ''
  const item = props.columns.find(i => String(i[props.columnNames.value]) === String(props.modelValue))
  return item ? item[props.columnNames.text] : ''
})

function onConfirm(value) {
  const selectedValue = value.selectedValues?.[0]
  const selectedItem = value.selectedOptions?.[0]
  
  if (selectedItem) {
    // 先触发 update:modelValue，保持双向绑定
    emit('update:modelValue', selectedItem[props.columnNames.value])
    
    // 再触发 confirm 事件，让父组件可以处理额外逻辑
    emit('confirm', {
      value: selectedItem[props.columnNames.value],
      label: selectedItem[props.columnNames.text],
      selected: selectedItem,
      event: value
    })
    
    // 如果没有监听 confirm 事件，则自动触发 change 事件
    if (!emit('change')) {
      emit('change', {
        value: selectedItem[props.columnNames.value],
        label: selectedItem[props.columnNames.text],
        selected: selectedItem
      })
    }
  }
  
  showPicker.value = false
}
</script>
